import { createFeatureSelector, createSelector } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import {
  CHAT_FEATURE_KEY,
  State
} from './chat.reducer';

// Lookup the 'Chat' feature state managed by NgRx
export const getChatState = createFeatureSelector<State>(CHAT_FEATURE_KEY);

export const getChatId = createSelector(
  getChatState,
  (state: State) => state.chatId
)

export const getChatCount = createSelector(
  getChatState,
  (state: State) => state.chatCount
)

export const getMessages = createSelector(
  getChatState,
  (state) => state.messages
)

export const getNewMessages = createSelector(
  getChatState,
  (state) => state.newMessages
)

export const getLoadMoreMessages = createSelector(
  getChatState,
  (state) => state.loadMoreMessages
)

export const getInitialized = createSelector(
  getChatState,
  (state: State) => state.isInitialized
);

export const getChatLoading = createSelector(
  getChatState,
  (state: State) => state.loading
);

export const getAuth = createSelector(
  getChatState,
  (state: State) => state.auth
)

export const getIdentity = createSelector(
  getChatState,
  (state: State) => state.identity
)


/// VIDEO SELECTORS
export const getVideoRoomId = createSelector(
  getChatState,
  (state: State) => state.videoRoomId
)
